import { HTMLAttributes } from "react";
import { StyledHeader } from "./Header.styles";
import { IconKeyLogo } from "../Icons";
import LanguageWidget from "../LanguageWidget";

type HeaderProps = HTMLAttributes<HTMLDivElement>;

const Header = (props: HeaderProps) => (
  <StyledHeader {...props}>
    <IconKeyLogo width={133} height={32} />
    <LanguageWidget />
  </StyledHeader>
);

export default Header;
